import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { Action, createReducer, on } from '@ngrx/store';
import { addFence, addManyFences, removeFence } from '@app/store/faxe/fences/fence.actions';
import { FenceRace } from '@app/store/faxe/fences/model/fence-race';
import { sapiensEntityState } from '@app/store/faxe/sapiens-entity-state';

export const identifier = (a: FenceRace): string => a.fenceGuid;

export const adapter: EntityAdapter<FenceRace> = createEntityAdapter<FenceRace>({
  selectId: identifier
});

export type FenceEntityState = EntityState<FenceRace>;

export const initialState: FenceEntityState = adapter.getInitialState({
  meta: {
    isReportable: undefined,
    timestamp: Date.now()
  }
});

const reducer = createReducer(
  initialState,
  on(addFence, (state, { model }) => adapter.addOne(model, state)),
  on(addManyFences, (state, { models }) => adapter.addMany(models, state)),
  on(removeFence, (state, { fenceId }) => adapter.removeOne(fenceId, state))
);

export const fenceReducer: (state: (FenceEntityState | undefined), action: Action) =>
  EntityState<FenceRace> = (state: FenceEntityState | undefined, action: Action) =>
  reducer(state, action);

const {
  selectAll
} = adapter.getSelectors();

export const selectAllFence = selectAll;


